import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import { Link } from "react-router-dom";
import { Grid, Button, Form, Icon } from "semantic-ui-react";
import { ControlledCheckbox, ControlledInput } from "./ControlledForm";
import queryString from "query-string";

export const LoginForm = ({ site, onSubmit, username, allowRememberMe, isLoading }: any) => {
  const { control, handleSubmit } = useFormContext();
  const { redirect } = queryString.parse(window.location.search, { parseBooleans: true });
  const [showPassword, setShowPassword] = useState(false);
  const renderIcon = (showPassword: boolean) => (
    <Icon
      name={showPassword ? "eye slash" : "eye"}
      link
      onClick={() => setShowPassword(!showPassword)}
      aria-label={showPassword ? "Hide password" : "Show password"}
      title={showPassword ? "Hide password" : "Show password"}
    />
  );

  const isPublicLogin = window.location.pathname.startsWith(`/${site}/public`);
  const forgotPath = isPublicLogin ? "forgot/public" : "forgot";

  function buildForgotPasswordPath() {
    if (redirect) return `/${site}/${forgotPath}?redirect=${encodeURIComponent(redirect as string)}`;
    return `/${site}/${forgotPath}`;
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Field required>
        <label htmlFor='email'>{username.label}</label>
        <ControlledInput name='email' control={control} autoComplete='email' />
      </Form.Field>
      <Form.Field required>
        <label htmlFor='password'>Password</label>
        <ControlledInput
          type={showPassword ? "text" : "password"}
          name='password'
          control={control}
          icon={renderIcon(showPassword)}
          iconPosition='right'
          autoComplete='current-password'
        />
      </Form.Field>
      <Form.Field>{allowRememberMe && <ControlledCheckbox name='remember' label='Remember me' />}</Form.Field>
      <Grid columns='equal' verticalAlign='middle' textAlign='center' style={{ marginTop: 16, marginBottom: 4 }}>
        <Grid.Column>
          <Button
            className='permitsButton'
            type='submit'
            fluid
            primary
            size='large'
            loading={isLoading}
            disable={isLoading}
          >
            Sign In
          </Button>
        </Grid.Column>
        <Grid.Column>
          <Link to={buildForgotPasswordPath()}>Forgot Password</Link>
        </Grid.Column>
      </Grid>
    </Form>
  );
};

export default LoginForm;
